import { useEffect, useState } from "react";

const navLinks = [
  { label: "首页", href: "#home" },
  { label: "漫画分类", href: "#categories" },
  { label: "热门推荐", href: "#hot" },
  { label: "完结排行榜", href: "#ranking" },
  { label: "用户口碑", href: "#reviews" },
  { label: "常见问题", href: "#faq" },
  { label: "关于我们", href: "#about" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "border-b border-background-200 bg-background-50/90 backdrop-blur-md"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6" aria-label="主导航">
        <a
          href="#home"
          className={`flex items-center gap-2 font-heading text-xl transition-colors ${
            scrolled ? "text-foreground-950" : "text-white"
          }`}
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-white">
            <i className="ri-book-open-fill text-lg" aria-hidden="true" />
          </span>
          高清韩国漫画
        </a>

        <div className="hidden items-center gap-1 lg:flex">
          {navLinks.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className={`rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                scrolled
                  ? "text-foreground-700 hover:bg-background-100 hover:text-primary-600"
                  : "text-white/90 hover:bg-white/10 hover:text-white"
              }`}
            >
              {item.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-2">
          <a
            href="#hot"
            className={`hidden items-center gap-1.5 whitespace-nowrap rounded-full px-4 py-2 text-sm font-semibold transition-colors sm:inline-flex ${
              scrolled
                ? "bg-primary-500 text-white hover:bg-primary-600"
                : "bg-white/15 text-white hover:bg-white/25 backdrop-blur"
            }`}
          >
            <i className="ri-fire-fill" aria-hidden="true" />
            开始追更
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label={open ? "关闭菜单" : "打开菜单"}
            aria-expanded={open}
            className={`inline-flex h-10 w-10 items-center justify-center rounded-lg lg:hidden ${
              scrolled ? "text-foreground-800 hover:bg-background-100" : "text-white hover:bg-white/10"
            }`}
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} aria-hidden="true" />
          </button>
        </div>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-3 lg:hidden">
          <div className="flex flex-col gap-1">
            {navLinks.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm font-medium text-foreground-700 hover:bg-background-100 hover:text-primary-600"
              >
                {item.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}